/* eslint-disable @typescript-eslint/no-explicit-any */
interface Dimensions {
    width: number;
    height: number;
}

export class MeasurementUtils {
    public static isPercentage = (value: string): boolean => typeof value === "string" && value.indexOf("%") > -1;

    public static percentToPx = (value: any, comparativeValue: number): string => {
        if (value.indexOf("px") > -1 || value === "auto" || !comparativeValue) return value;
        const percent = parseInt(value);
        return (percent / 100) * comparativeValue + "px";
    };

    public static pxToPercent = (value: any, comparativeValue: number): number => {
        const val = (Math.abs(value) / comparativeValue) * 100;
        if (value < 0) return -1 * val;
        else return Math.round(val);
    };

    public static getElementDimensions = (element: HTMLElement): Dimensions => {
        const computedStyle = getComputedStyle(element);

        let height = element.clientHeight;
        let width = element.clientWidth;

        height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
        width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);

        return {
            width,
            height,
        };
    };
}
